import { apiClient } from './request';
import { TraceDetailsSchema, type Trace } from '@/proto/agentplatform/v1/langfuse_pb';

import {
  type ListTracesRequest,
  ListTracesRequestSchema,
  ListTracesResponseSchema,
  type GetTraceDetailsRequest,
  GetTraceDetailsRequestSchema,
  GetTraceDetailsResponseSchema,
  type GetMetricsRequest,
  GetMetricsRequestSchema,
  GetMetricsResponseSchema,
  type GetSandboxMetricsRequest,
  GetSandboxMetricsRequestSchema,
  GetSandboxMetricsResponseSchema,
} from '@/proto/agentplatform/httpv2/observability_pb';

import { fromJson, type JsonValue, toJson } from '@bufbuild/protobuf';

/** listTraces 返回的兼容形状，保持页面既有的 `data.data` / `data.total` / `data.page` / `data.totalPages` 读法。 */
export interface ListTracesResult {
  data: Trace[];
  total: number;
  page: number;
  totalPages: number;
}

export const langfuseApi = {
  listTraces: async (params: ListTracesRequest): Promise<ListTracesResult> => {
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/ListTraces',
      toJson(ListTracesRequestSchema, params)
    );
    const resp = fromJson(ListTracesResponseSchema, responseObject.data);
    return {
      data: resp.data?.items ?? [],
      total: resp.data?.total ?? 0,
      page: resp.data?.page ?? 1,
      totalPages: resp.data?.totalPages ?? 1,
    };
  },

  getTraceDetails: async (params: GetTraceDetailsRequest): Promise<JsonValue> => {
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/GetTraceDetails',
      toJson(GetTraceDetailsRequestSchema, params)
    );
    const resp = fromJson(GetTraceDetailsResponseSchema, responseObject.data);
    return resp.data ? toJson(TraceDetailsSchema, resp.data) : {};
  },

  getMetrics: async (query: GetMetricsRequest): Promise<JsonValue> => {
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/GetMetrics',
      toJson(GetMetricsRequestSchema, query)
    );
    const resp = fromJson(GetMetricsResponseSchema, responseObject.data);
    return (resp.data ?? {}) as JsonValue;
  },

  getSandboxMetrics: async (query: GetSandboxMetricsRequest): Promise<JsonValue> => {
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/GetSandboxMetrics',
      toJson(GetSandboxMetricsRequestSchema, query)
    );
    const resp = fromJson(GetSandboxMetricsResponseSchema, responseObject.data);
    return (resp.data ?? {}) as JsonValue;
  },
};
